export interface IClientConfig {
  baseUrl: string;
  mapUrl: string;
  storesUrls: {
    google: string;
    apple: string;
  };
}

/* tslint:disable:max-line-length */
export const config: IClientConfig = {
  baseUrl: '//master.dev3.cian.ru',
  mapUrl: '//map.cian.ru',
  storesUrls: {
    apple: 'http://m.onelink.me/1229ee8d ',
    google: 'http://m.onelink.me/318c04d5',
  },
};
/* tslint:enable:max-line-length */
